import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getRecentSleeves } from "../../api/getSleeves";
import Skeleton from "react-loading-skeleton";

class RecentSleevesContainer extends React.Component {
  componentDidMount() {
    this.props.request();
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const sleeves = (data && data.data) || [];
    if (loading) {
      return <Skeleton count={3} />;
    }
    if (!loading && sleeves.length === 0) {
      return null;
    }
    return render({ sleeves, loading, failure });
  };
}

export default CreateContainer(getRecentSleeves, RecentSleevesContainer);
